import { createFileRoute } from '@tanstack/react-router';
import { SettingsPage } from '../features/parent/SettingsPage';
import { RequireAuth } from '../features/auth/RequireAuth';

export const Route = createFileRoute('/parent/settings')({
  component: () => <RequireAuth role="parent">{(me) => <SettingsPage me={me} />}</RequireAuth>,
});
